import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './Badge.module.scss';

const cx = classnames.bind(styles);

const Badge = ({
  className = '',
  color = 'blue',
  style = {},
  children,
  theme = 'round',
}) => {
  return (
    <span className={cx('item', color, theme, className)} style={style}>{children}</span>
  )
}

Badge.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(['orange', 'cyan', 'pink', 'blue', 'gray', 'black-reverse']),
  theme: PropTypes.oneOf(['round', 'semi-round'])
}

export default Badge;
